import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css'],
})
export class ProductDetailComponent {

  nameproduct:string = "";

  constructor(private route: ActivatedRoute) {
    console.log(route.snapshot.params['id']);
    console.log(route.snapshot.params['name']);

    this.nameproduct = route.snapshot.params['name'];

  }
}
